import { withConfig } from "@/utils/withConfig";
import { ThankYouPage } from "./ThankYouPage";
import type { ThankYouPageProps } from "./ThankYouPageProps";

export * from "./ThankYouPage";
export type { ThankYouPageProps };

export const ThankYouPageWithConfig = withConfig<ThankYouPageProps>(
  ThankYouPage,
  "thank_you_page",
);
